import { get } from 'lodash';

const getAgeSelector = state => get(state, ['parental', 'data', 'age']);
const getParentalPurchaseSelector = state => get(state, ['parental', 'data', 'purchase']);

export default state => {
  return {
    age: getAgeSelector(state),
    purchase: getParentalPurchaseSelector(state),
  };
};
